import React, { Component } from 'react';
import { FaTimes } from 'react-icons/fa';
import ApiRequest from '../../libs/request';
import './SearchModal.css';

class SearchModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchInput: this.props.searchInput || '',
      pending: [],
    };
  }

  handleSearchInput = (e) => {
    const value = e.target.value;
    this.setState({ searchInput: value });
    if (this.props.onSearchChange) {
      this.props.onSearchChange(e);
    }
  };

  handleClearSearch = () => {
    this.setState({ searchInput: '' });
    if (this.props.onClearSearch) {
      this.props.onClearSearch();
    }
  };

  handleFriendClick = (e) => {
    let _pending = this.state.pending;
    var api = new ApiRequest("post", "/user/send-friend-request");
    if (e.target.getAttribute("isFriend") == "1") {
      api = new ApiRequest("post", "/user/delete-friend");
    }
    var id = e.target.id;
    api.send({ friend_id: id }, () => {
      if (_pending.indexOf(id) === -1) {
        _pending.push(id);
      }
      this.setState({ pending: _pending });
    });
  };

  render() {
    const { isOpen, onClose, searchResults } = this.props;
    const { searchInput } = this.state;

    if (!isOpen) return null;

    return (
      <div className="modal-backdrop" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2>Search</h2>
            <button 
              className="modal-close-btn" 
              onClick={onClose}
              aria-label="Close search modal"
            >
              <FaTimes size={24} />
            </button>
          </div>
          
          <div className="modal-body">
            <input
              type="text"
              placeholder="Search people, companies, projects..."
              value={searchInput}
              onChange={this.handleSearchInput}
              className="search-modal-input"
              autoFocus
            />

            {searchInput && Object.keys(searchResults).length > 0 ? (
              <div className="search-modal-results">
                {searchResults.users && searchResults.users.length > 0 && (
                  <div className="search-results-section">
                    <h4>Users</h4>
                    {searchResults.users.map((user, idx) => {
                      var _btnCss =
                        this.state.pending.indexOf(user.id.toString()) > -1 ||
                        user.is_friend ||
                        user.request_sent
                          ? "requested"
                          : "";
                      var _text =
                        this.state.pending.indexOf(user.id.toString()) > -1 || user.request_sent
                          ? "REQUESTED"
                          : "ADD FRIEND";
                      if (user.is_friend) {
                        _text = "REMOVE";
                      }
                      var _button = null;
                      if (this.props.user?.id !== user.id) {
                        _button = (
                          <button
                            id={user.id}
                            isFriend={user.is_friend}
                            className={"actionbtn " + _btnCss}
                            type="button"
                            onClick={this.handleFriendClick}
                          >
                            {_text}
                          </button>
                        );
                      }
                      return (
                        <div key={idx} className="search-result-item">
                          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                            <img 
                              src={user.profile_photo} 
                              alt={user.first_name}
                              className="search-result-avatar"
                            />
                            <div className="search-result-info">
                              <p className="search-result-name">{user.first_name} {user.last_name}</p>
                            </div>
                          </div>
                          {_button && <div className="search-result-action">{_button}</div>}
                        </div>
                      );
                    })}
                  </div>
                )}

                {searchResults.companies && searchResults.companies.length > 0 && (
                  <div className="search-results-section">
                    <h4>Companies</h4>
                    {searchResults.companies.map((company, idx) => (
                      <div key={idx} className="search-result-item">
                        <img 
                          src={company.logo} 
                          alt={company.name}
                          className="search-result-avatar"
                        />
                        <div className="search-result-info">
                          <p className="search-result-name">{company.name}</p>
                          {company.type && <p className="search-result-title">{company.type}</p>}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {searchResults.projects && searchResults.projects.length > 0 && (
                  <div className="search-results-section">
                    <h4>Projects</h4>
                    {searchResults.projects.map((project, idx) => (
                      <div key={idx} className="search-result-item">
                        <img 
                          src={project.image} 
                          alt={project.name}
                          className="search-result-avatar"
                        />
                        <div className="search-result-info">
                          <p className="search-result-name">{project.name}</p>
                          {project.description && <p className="search-result-title">{project.description}</p>}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ) : searchInput ? (
              <div className="search-modal-no-results">
                <p>No results found for "{searchInput}"</p>
              </div>
            ) : (
              <div className="search-modal-placeholder">
                <p>Start typing to search...</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default SearchModal;
